import {
	VEHICLE_DATA_CRITICAL_AFTER_HOURS,
	VEHICLE_DATA_OUTDATED_AFTER_HOURS,
	VehicleDataAge,
} from '@agilox/common';

export const STALE_HOURS_BY_LEVEL: Partial<Record<VehicleDataAge, number>> = {
	[VehicleDataAge.OUTDATED]: VEHICLE_DATA_OUTDATED_AFTER_HOURS,
	[VehicleDataAge.CRITICAL]: VEHICLE_DATA_CRITICAL_AFTER_HOURS,
};
